import React, {useRef, useState} from 'react';
import {Stepper, Step, StepLabel, Button, Container, Box} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import {useBoolean} from 'src/hooks/use-boolean';
import {ConfirmLMSDialog} from '@components/custom-dialog';
import {useOnlineContext} from '../../../ModulePageComponents/AdditionData/OnlineTestContext';
import AdvanedOptionsPostLearning from './AdvancedOptionsPostLearning';
import PostLearningPublish from './PostLearningPublish';
import QuestionSetupPostLearning from './QuestionSetupPostLearning';
import AssessmentSetupPost from './AssessmentSetup';
interface AssessmentStepperProps {
  onClose: () => void;
}
// const steps = [
//   {key: 0, value: 'Assessment Setup'},
//   {key: 1, value: 'Questions'},
//   {key: 2, value: 'Advanced Options'},
//   {key: 3, value: 'Publish'}
// ];
const steps = [
  {key: 0, value: 'Assessment Setup'},
  {key: 1, value: 'Questions'},
  {key: 2, value: 'Publish'}
];
interface ChildFormMethods {
  submitForm: () => Promise<any>;
}
const AssessmentLinking: React.FC<AssessmentStepperProps> = ({onClose}) => {
  const {screenLoader} = useOnlineContext();

  const confirm = useBoolean();
  const [activeStep, setActiveStep] = useState(0);
  const {screenSave, setScreenSave} = useOnlineContext();
  // Ref to store child save methods
  const childSaveRef = useRef<ChildFormMethods | null>(null);

  const handleNavigation = async (nextStep: number) => {
    if (childSaveRef.current) {
      const isSaved = await childSaveRef.current.submitForm();
      if (!isSaved) {
        return;
      }
    }
    setActiveStep(nextStep);
  };
  const handleclose = async (value: boolean) => {
    if (activeStep !== 0) {
      //console.log('activeStep3', activeStep);
      if (value) {
        if (childSaveRef.current) {
          const isSaved = await childSaveRef.current.submitForm();
          if (!isSaved) {
            return;
          }
        }
      }
    } else if (value) {
      if (childSaveRef.current) {
        const isSaved = await childSaveRef.current.submitForm();
        if (!isSaved) {
          return;
        }
      }
    }
    onClose();
  };
  const handlePublish = async () => {
    // confirm.onFalse();
    handleclose(false);
  };

  const handleNext = () => handleNavigation(activeStep + 1);
  const handleBack = () => handleNavigation(activeStep - 1);
  const handleStepClick = (stepKey: number) => handleNavigation(stepKey);

  const handleSave = () => {
    console.log('Publishing assessment');
  };

  const getStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <AssessmentSetupPost ref={childSaveRef} />;
      case 1:
        return <QuestionSetupPostLearning ref={childSaveRef} />;
      case 2:
        return <PostLearningPublish handlePublish={handlePublish} />;
        // return <AdvanedOptionsPostLearning ref={childSaveRef} />;
      case 3:
        return <PostLearningPublish handlePublish={handlePublish} />;
      default:
        return 'Unknown step';
    }
  };

  return (
    <Container>
      <Box sx={{py: 3}}>
        <Stepper activeStep={activeStep}>
          {steps.map(step => (
            <Step key={step.key}>
              <StepLabel
                sx={{cursor: 'pointer !important'}}
                onClick={() => handleStepClick(step.key)}>
                {step.value}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{minHeight: '75vh', py: 2}}>{getStepContent(activeStep)}</Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2
          }}>
          <Box>
            {activeStep > 0 && (
              <LoadingButton
                loading={screenSave}
                onClick={handleBack}
                variant="outlined"
                sx={{mr: 1}}>
                Back
              </LoadingButton>
            )}
            {activeStep < steps.length - 1 && (
              <LoadingButton
                loading={screenSave}
                onClick={handleNext}
                variant="contained"
                color="primary">
                Next
              </LoadingButton>
            )}
          </Box>
          <Button
            onClick={() => confirm.onTrue()}
            variant="contained"
            color="error">
            close
          </Button>
        </Box>
      </Box>
      <ConfirmLMSDialog
        open={confirm.value}
        onClose={() => {
          confirm.onFalse();
          handleclose(true);
        }}
        onCancel={confirm.onFalse}
        title="Close"
        content="Are you sure want to Close without saving?"
        action={
          <LoadingButton
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
              handleclose(false);
            }}>
            Yes
          </LoadingButton>
        }
      />
    </Container>
  );
};

export default AssessmentLinking;
